import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_TASK_MASTER } from "../../../api-setup/api-endpoints";

export const fetchTaskMasterData = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_sort_number: 2,
      in_sort_order: "ASC",
      in_page_row_offset: 0,
      in_page_rows: null,
      in_filter: "",
    };

    const response = await POSTAPI(false, GET_ALL_TASK_MASTER, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      // Transform the data to dropdown format with id and text properties
      // Using task_mstr_key as id and name as text
      const transformedData = rawData.map((task) => ({
        id: task.task_mstr_key,
        text: task.name || task.task_name || "Unknown",
      }));

      return {
        success: true,
        taskMasterData: rawData,
        transformedData: transformedData,
        count: transformedData.length,
      };
    } else {
      console.error("Failed to fetch task master data:", response?.message || "Invalid response structure");
      return {
        success: false,
        taskMasterData: [],
        transformedData: [],
        count: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching task master data:", error);
    return {
      success: false,
      taskMasterData: [],
      transformedData: [],
      count: 0,
      error: error.message,
    };
  }
};
